import { call, put, takeEvery } from "redux-saga/effects";
import { get, noop } from "lodash-es";
import {
  fetch_pre_check,
  fetch_details,
  trigger_otp,
  create_esign_request,
} from "../../apis/accountClosure.js";
import {
  fetchPreCheck,
  setPreCheck,
  getDetails,
  setDetails,
  triggerOtp,
  setOtpLinks,
  createEsign,
  setEsignData,
} from "../reducers/accountClosure.js";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";

export default function* accountClosureSagas() {
  yield takeEvery(fetchPreCheck.toString(), handlefetchPreCheck);
  yield takeEvery(getDetails.toString(), handleGetDetails);
  yield takeEvery(triggerOtp.toString(), handleTriggerOtp);
  yield takeEvery(createEsign.toString(), handleCreateEsign);
}

function* handleGetDetails({ payload }) {
  const { Api, token = "", data, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const resp = yield call(fetch_details, Api, data, token);
    yield put(setDetails(resp));
    yield call(sagaCallback, resp);
  } catch (err) {
    console.error("error is in handleGetDetails", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handlefetchPreCheck({ payload }) {
  const { Api, screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const resp = yield call(fetch_pre_check, Api);
    const result = get(resp, "result_data", {});
    yield put(setPreCheck(result));
  } catch (err) {
    console.error("error is in handlefetchPreCheck", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleTriggerOtp({ payload }) {
  const { Api, screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const resp = yield call(trigger_otp, Api);
    yield put(setOtpLinks(resp));
    yield call(sagaCallback);
  } catch (err) {
    console.error("error is in handleTriggerOtp", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleCreateEsign({ payload }) {
  const { Api, screen, data, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const resp = yield call(create_esign_request, Api, data);
    const result = resp.esign_req;
    yield put(setEsignData(result));
    yield call(sagaCallback);
  } catch (err) {
    console.error("error is in handleCreateEsign", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}
